import theme from '../../theme';

export const InfoIconSx = (state: 'information' | 'error') => ({
  margin: '18px',
  path: {
    stroke: state === 'error' ? theme.palette.error.main : undefined,
  },
});

export const TitleSx = {
  fontSize: '24px',
  fontWeight: 600,
  color: theme.palette.customColors.gray[950],
};

export const ContentSx = {
  fontSize: '14px',
  color: theme.palette.customColors.gray[950],
};

export const EmptyContentSx = { margin: '15px' };

export const ActionsSx = {
  width: '100%',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 2,
};

export const CancelButtonSx = {
  color: theme.palette.customColors.gray[950],
  height: '44px',
};

export const ConfirmButtonSx = (state: 'information' | 'error') => ({
  height: '44px',
  backgroundColor:
    state === 'error'
      ? theme.palette.error.main
      : theme.palette.customColors.blue[500],
  '&:hover': {
    backgroundColor:
      state === 'error'
        ? theme.palette.customColors.error.hover
        : theme.palette.customColors.blue[700],
  },
  '&.Mui-disabled': {
    backgroundColor:
      state === 'error'
        ? theme.palette.error.main
        : theme.palette.customColors.blue[500],
    color: theme.palette.common.white,
    opacity: 0.55,
    pointerEvents: 'auto',
  },
});

export const PaperSx = {
  width: '520px',
};

export const ErrorMessageSx = {
  color: theme.palette.error.main,
  marginTop: '12px',
};
